import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import Dialog from "components/dialog";
import IconButton from "components/icon-button";
import Icon from "components/icon";
import withStyles from "components/with-styles";
import styles from "./styles/add-source-button.css.js";
import { ActionButton } from "components/buttons";
import { injectIntl } from "react-intl";
import { useMutation } from "@apollo/react-hooks";
import { SourceSelect } from "components/select";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { addSourceToDeploymentMutation } from "./partial";
import { useLoadingContext } from "components/loading-spinner-overlay";

const AddSourceButton = ({ actionButton = false, classes, intl, deploymentId, onSuccess }) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  const [sourceId, setSourceId] = useState();
  const [addSourceToDeployment] = useMutation(addSourceToDeploymentMutation);
  const [open, setOpen] = useState(false);
  const { setLoading } = useLoadingContext();

  const handleOpen = useCallback(e => {
    setOpen(true);
    e.stopPropagation();
  }, []);

  const handleClose = useCallback(e => {
    setOpen(false);
    e.stopPropagation();
  }, []);

  const handleAssetChangeSpace = () => {
    if (!sourceId) {
      return;
    }

    setLoading(true);
    const updatedData = addSourceToDeployment({
      variables: {
        customerId: currentCustomerId,
        deploymentId,
        sourceId,
      },
    });

    return updatedData
      .then(() => {
        setOpen(false);
        setLoading(false);
        onSuccess();
      })
      .catch(error => {
        setLoading(false);
        throw new Error("Error adding source to deployment", error);
      });
  };

  const handleChange = ({ id }) => setSourceId(id);

  return (
    <>
      {actionButton ? (
        <ActionButton icon="add-to-queue" onClick={handleOpen} />
      ) : (
        <div className={classes.tooltipContainer}>
          <IconButton className={classes.iconButton} onClick={handleOpen}>
            <Icon name="add-to-queue" />
          </IconButton>
        </div>
      )}
      <Dialog
        title={intl.formatMessage({ id: "app.page.deployment.details.addSource" })}
        open={open}
        onClose={handleClose}
        onAccept={handleAssetChangeSpace}
      >
        <SourceSelect
          variables={{ withoutDeployment: true }}
          emptyValueText={null}
          value={sourceId}
          onChange={handleChange}
        />
      </Dialog>
    </>
  );
};

AddSourceButton.propTypes = {
  /**
   * Id de deployment al que se va a asociar
   **/
  deploymentId: PropTypes.string,
  /**
   * Indica si se muestra como un botón de acción
   **/
  actionButton: PropTypes.bool,
  /**
   * Callback que se invoca cuando se agrega la source al deployment
   */
  onSuccess: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(AddSourceButton));
